import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const headCells = [
    { id: 'idmulta', label: 'ID', width: '10px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'fechamulta', label: 'FECHA', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'descripcion', label: 'TIPO MULTA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'concepto', label: 'CONCEPTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'monto', label: 'MONTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'cancelada', label: 'PAGADA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
]
const TablaMultasComercio = props => {
    let op = require('../../../../src/modulos/datos');
    const [records, setRecords] = useState([]);
    const [filterFn] = useState({ fn: items => { return items; } })
    const {
        TblContainer,
        TblHead,
    } = useTableFijo(records, headCells, filterFn, 320);
    useEffect(() => {
        if (props.tabmulta) {
            setRecords(props.tabmulta);
        }
    }, [props.tabmulta]);

    return (
        <div className = 'col-12 m-0 mt-2 p-0'>
            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >
                <TblHead />

                <tbody>
                    {

                        records && records.map((item, index) => (
                            <tr key={item.idmulta} style={{ padding: "0" }}>
                                <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idmulta}</td>
                                <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechamulta).format('DD/MM/YYYY')}</td>
                                <td style={{ fontSize: "10px", textAlign: "left" }}>{item.descripcion.trim()}</td>
                                <td style={{ fontSize: "10px", textAlign: "left" }}>{item.concepto.trim()}</td>
                                <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                <td style={{ fontSize: "10px", textAlign: "center" }}>{item.cancelada ? 'SI' : 'NO'}</td>
                            </tr>

                        ))
                    }
                </tbody>

            </TblContainer>
        </div>
    );

}

export default TablaMultasComercio;
